// Function to update the cart drawer content
function updateCartDrawer() {
  fetch('/cart')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartContent = doc.querySelector('.cart-drawer');

      if (newCartContent) {
        const currentCartDrawer = document.querySelector('.cart-drawer');
        currentCartDrawer.innerHTML = newCartContent.innerHTML;

        // Reinitialize any scripts or sliders
        // initializeCartDrawerScripts();
        // onloadinitializeCartDrawerScripts();
        //initializeSlickSlider(); // Reinitialize the Slick Slider if necessary
      }
    })
    .catch(error => console.error('Error updating cart drawer:', error));
}

// Delegate click events for upsell buttons
document.addEventListener('click', function (event) {
  if (event.target.classList.contains('upsell-add-btn')) {
    event.preventDefault(); // Prevent default click behavior
    const button = event.target;
    const variantId = button.getAttribute('data-id');

    // Show loader or disable button
    button.textContent = 'Hinzufügen...';
    button.disabled = true;

    // Add product to the cart via AJAX
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Product added:', data);

        // Update cart drawer
        updateCartDrawer();

        // Reset button state
        button.textContent = 'Hinzufügen';
        button.disabled = false;
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Fehler beim Hinzufügen zum Warenkorb.');
        button.textContent = 'Hinzufügen';
        button.disabled = false;
      });
  }
});